let FunnelCode = {
    internet: 0,
    friend: 1,
    fromOtherLocation: 2,
    others: 3,
    text: ["인터넷", "친구소개", "타 지점 이용", "기타"]
}

export default FunnelCode;